import React, { useEffect, useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import toast, { Toaster, useToasterStore } from "react-hot-toast";
import Layout from "../Layout";
import Table, { TableProps } from "antd/lib/table";
import Loader from "../loader";
import '../../../src/custom.css'
import { fetchAllThumbnail, fetchSearchData, fetchThumbnailsBySiteId } from "../../Redux/Api/fetch.api";
import { getThumbnail } from "../../Redux/Actions/DashboardCount";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import PhotoIcon from '@mui/icons-material/Photo';
import { Tooltip } from 'antd';
import Switch from "react-switch";
import { useTranslation } from "react-i18next";

const AllThumbnailPage = () => {
    const { t } = useTranslation("dashboard");
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    // const allThumbnails = useSelector((state) => state.allDashboardReducer.thumbnail)
    const [imageModal, setImageModal] = useState(false)
    const [imageData, setImageData] = useState()
    const [pageSize, setPageSize] = useState(50);
    const [pageData, setPageData] = useState({});
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: 50,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['50', '100']
        }
    });
    //  const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize});
    const [search, setSearch] = useState("")
    const [searchData, setSearchData] = useState()
    const [searchClicked, setSearchClicked] = useState(false)
    const [searchError, setSearchError] = useState()
    const [count, setCount] = useState(0)
    const [total, setTotal] = useState()
    const [searchtotal, setSearchTotal] = useState()
    const [totalIndex, setCurrentIndex] = useState()
    const [initialData, setInitialData] = useState({})
    const comingsiteId = localStorage.getItem('SiteId');
    const [showAllData, setShowAllData] = useState(false);
    const [searchOptions, setSearchOptions] = useState({
        pagination: { current: 1 }, pageSize: pageSize
    })

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
        getAllThumbnailData(options, showAllData)
    }, [])

    const handleImageOpen = (row, i) => {

        setImageData(row)
        setImageModal(true)
    }

    const handleImageClose = () => {
        setImageModal(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleThumbnailSearch();
        }
    }


    const getAllThumbnailData = (options, showAllData) => {
        const siteIdToSend = showAllData ? 0 : comingsiteId;
        setLoading(true)
        if (options && options.pagination == undefined) {
            options.pagination = pageData.pagination;
            options.pageSize = pageData.pageSize;
        }
        fetchThumbnailsBySiteId(siteIdToSend)
            .then(response => {

                dispatch(getThumbnail(response.data.data)),
                    setTable(response.data.data.allThumbnailList)
                // setTotal(response.data.count)
                setTotal(response.data.data.totalCount)
                setOptions({
                    ...options,
                    pagination: {
                        pageSize: options.pagination.pageSize,
                        current: options.pagination.current,
                        total: response.data.data.totalCount,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
                setInitialData({
                    table: response.data.data.allThumbnailList,
                    option: {
                        pagination: {
                            current: options.pagination.current,
                            total: response.data.data.totalCount,
                            pageSizeOptions: ['50', '100'],
                            showSizeChanger: true,
                        }
                    }
                })
                setLoading(false)
            }).catch((err) => {
                console.log("Err : ", err);
            })


    }
    //for Searching
    const handleDataSearch = (e) => {
        setSearchError("")
        setSearch(e.target.value)
        setCount(e.target.value.length)
        if (e.target.value == "") {
            setSearchData(table)
        }
    }

    const handleSwitchChange = (checked) => {
        setShowAllData(checked);
        getAllThumbnailData(options, checked);
    };

    const handleThumbnailSearch = () => {
        if (search == "") {
            setSearchError(t("PleaseEnterFileName"));
        }
        else if (search != "") {
            var searchDataFinal = table.length > 0 ? table.filter(item => item.filename != null && item.filename.toLowerCase().startsWith(search.toLowerCase().trim()) || item.filename != null && item.filename.toLowerCase().includes(search.toLowerCase().trim())) : ""
            //  var searchDataFinal = table.length > 0 ? table.filter(item => item.qRcodeId.toString().startsWith(search)) : ""
            if (searchDataFinal.length < 1) {
                setSearchClicked(true)
                setSearchData("")
            }
            if (searchDataFinal.length > 0) {
                setSearchClicked(true)
                setSearchData(searchDataFinal)
                setSearchOptions({
                    ...searchOptions,
                    pagination: {
                        pageSize: searchOptions.pageSize,
                        current: searchOptions.pagination.current,
                        searchtotal: searchDataFinal.length,
                        pageSizeOptions: ['50', '100'],
                        showSizeChanger: true,
                    }
                })
            }
        }
    }



    const handleResetButton = () => {
        setSearchClicked(false)
        setSearch("")
        setSearchData("")
        setSearchError("")
        setTotal(initialData.table)
        setOptions(initialData.option)
        getAllThumbnailData(options, showAllData)
    }

    const handleChange = (pagination) => {
        setOptions(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize,
            }
        }));

        getAllThumbnailData({
            pagination: {
                current: pagination.current,
                pageSize: pagination.pageSize
            }
        }, true); // Pass `true` to force siteId = 0
    };

    //const handleChange = (pagination, sorter) => {
    //    const updatedOptions = { ...options, pagination };
    //    setOptions(updatedOptions);
    //    setPageData(updatedOptions)
    //};

    const getFullDate = (date) => {

        const dateAndTime = date.split('T');
        const time = dateAndTime[1].split(':')
        const newtime = time[0] + ':' + time[1]
        const times = time[0] > 12 ? "0" + time[0] % 12 : time[0]
        const newtime1 = times + ':' + time[1]
        if (time[0] && time[0] >= 12) {
            return dateAndTime[0].split('-').reverse().join('-') + ', ' + newtime1 + " PM ";
        }
        else {
            return dateAndTime[0].split('-').reverse().join('-') + ', ' + newtime + " AM ";

        }

    };

    const columns = [
        {
            title: t("SrNo"),
            dataIndex: "Index",
            render: (text, record, index) => { setCurrentIndex(`${(options.pagination.current === undefined ? 0 : options.pagination.current - 1) * 10 + index + 1}`); return `${(options.pagination.current === undefined ? 0 : options.pagination.current - 1) * 10 + index + 1}` },
        },
        {
            title: t("MediaFileName"),
            dataIndex: "filename",
            render: (filename) => <Tooltip title={filename}>{filename}</Tooltip>,
        },
        {
            title: t("MediaFileExtension"),
            dataIndex: "extension"
        },
        {
            title: t("MediaFileSize"),
            dataIndex: "size",
            render: (text, row, i) => {

                if (row.size) {
                    var result = row.size;
                    if (result > 1024) {
                        const mbsize = result / 1024
                        return Math.trunc(mbsize) + " mb"
                    }
                    if (result < 1024) {
                        return row.size + " kb"
                    }
                    //if (result > 1000) {
                    //    return result + " gb"
                    //}
                }
                else {
                    return ""
                }
            }
        },

        {
            title: t("UploadDate"),
            dataIndex: "upload_Date",
            className: "upload_Date",
            key: 'upload_Date',

            render: ((date) => getFullDate(date))
        },

        {
            title: t("Preview"),
            className: "preview",
            render: (parent_QRCodeID, row, i) => <>
                <Tooltip title={t("ClickToPreview")}>     
                    <PhotoIcon style={{ color: "#b97a57", cursor: "pointer" }}
                        onClick={() => handleImageOpen(row, i)} />
                </Tooltip>
            </>

        },
    ]


    return (
        <Layout title={t("ThumbnailTitle")}>
            {!searchClicked ?
                <>
                    <div className="position-relative">
                        <div className="card-box-header d-inline-flex w-100 align-items-center gap-3 m-0">
                            {/* <h4 className="m-0">Thumbnail</h4> */}
                            <div className='d-inline-flex gap-2 filter-box1 flex-wrap' >
                                <span>{t("SearchMediaFile")}</span>
                                <div className="d-flex flex-column gap-2 width-box position-relative">

                                    <input type="text" className='form-control searchQR'
                                        value={search} placeholder={t("EnterFileName")} onChange={(e) => {
                                            handleDataSearch(e); setSearchError(false)
                                        }}
                                        onKeyDown={(e) => handleKeyPress(e)}
                                    ></input>
                                    {
                                        < small className="text-danger d-block qRcodeError top-100">{searchError}</small>
                                    }
                                </div>
                                <button onClick={() => handleThumbnailSearch()}
                                    className="searchButton">{t("Search")}</button>
                                {/* {
                                    < small className="text-danger d-block mt-2 searchError forDesk">{searchError}</small>
                                } */}
                            </div>

                            <div className="d-flex align-items-center">
                                <label className="filter-col me-3 mb-0">{t("ShowAll")}</label>
                                <Switch
                                    onChange={handleSwitchChange}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    checked={showAllData}
                                    onColor="#bb9977"
                                    handleDiameter={20}
                                    height={16}
                                    width={35}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    onHandleColor="#b97a57"

                                />
                            </div>
                        </div>
                    </div>
                    <div className="Viewer-table position-relative ellipsss thumbnail_list">
                        {loading ? <Loader /> : ''}
                        <Table
                            className='table-responsive antd--detail-table Viewer-table'
                            columns={columns}
                            dataSource={table}
                            pagination={
                                total > 50 ? options.pagination : false
                            }
                            //pagination={options.pagination.total > 9 && totalIndex > 9 ? options.pagination : false}
                            onChange={handleChange}
                        // paginationTotalRows={total}
                        />
                    </div>
                </> :
                <>
                    <div className="position-relative">
                        <div className="card-box-header d-inline-flex w-100 align-items-center gap-3 m-0">
                            {/* <h4 className="m-0">Thumbnail</h4> */}
                            <div className='position-relati' >
                                {t("SearchMediaFile")}
                                <input type="text" className='form-control searchQR'
                                    value={search} placeholder={t("EnterFileName")} onChange={(e) => {
                                        handleDataSearch(e); setSearchError(false)
                                    }}></input>
                                {
                                    < small className="text-danger d-block mt-2 searchError formob">{searchError}</small>
                                }
                                <button className='searchButton ml-4' onClick={() => handleThumbnailSearch()} >{t("Search")}</button>
                                {search == "" ? "" : <button className='searchButton ml-4' onClick={() => handleResetButton()} >{t("Reset")}</button>}
                                {
                                    < small className="text-danger d-block mt-2 searchError forDesk">{searchError}</small>
                                }
                            </div>

                            <div className="d-flex align-items-center">
                                <label className="filter-col me-3 mb-0">{t("ShowAll")}</label>
                                <Switch
                                    onChange={handleSwitchChange}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    checked={showAllData}
                                    onColor="#bb9977"
                                    handleDiameter={20}
                                    height={16}
                                    width={35}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    onHandleColor="#b97a57"

                                />
                            </div>
                        </div>
                    </div>
                    <div className="Viewer-table position-relative ellipsss thumbnail_list">
                        {loading ? <Loader /> : ''}
                        <Table
                            className='table-responsive antd--detail-table Viewer-table '
                            columns={columns}
                            dataSource={searchData}
                            pagination={
                                searchtotal > 50 ? options.pagination : false
                            }
                            //  pagination={options.pagination.total > 9 && totalIndex > 9 ? options.pagination : false}
                            onChange={handleChange}
                        // paginationTotalRows={total}
                        />
                    </div>
                </>}

            <Modal
                show={imageModal}
                onHide={handleImageClose}
                backdrop="static"
                keyboard={false}
                dialogClassName="modal-dialog-zoom"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{imageData ?
                        <> <h5 className="mt-2" style={{ color: "#b97a57", display: "inline", float: "left" }}>{t("MediaFileNameLabel")} </h5><h5 className="mt-2 ml-2" style={{ display: "inline", float: "right" }}>{imageData.filename}.{imageData.extension}</h5></>
                        : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        <div className="align-items-center d-flex flex-wrap img-section justify-content-center m-0">
                            <img className="thumb_image" style={{ maxWidth: 400 }} src={imageData ? imageData.fileurl : ""}></img>
                        </div>
                    }
                </Modal.Body>
            </Modal>

        </Layout>
    )
}
export default connect()(AllThumbnailPage);